<template>
  <div v-if="tableField.length > 0">
    <el-table
        :data="tableData"
        style="width: 100%"
        @selection-change="handleSelectionChange">
      <el-table-column
          v-if="tableConfigIn.isCheckBox == 1"
          type="selection"
          width="55">
      </el-table-column>
      <block v-for="(item,index) in tableFieldIn" :key="index">
        <el-table-column
             v-if="item.isSlot == 1"
            :label="item.columnName"
            :width="item.width">
          <template slot-scope="scope">
            <slot :name="item.columnCode" :item="scope.row"></slot>
          </template>
        </el-table-column>
        <el-table-column
            v-else
            :prop="item.columnCode"
            :label="item.columnName"
            :width="item.width">
        </el-table-column>
      </block>

      <el-table-column
          v-if="tableConfigIn.isOpera == 1"
          :fixed="tableConfigIn.fixed"
          label="操作" :width="tableConfigIn.operaWidth">
        <template slot-scope="scope">
          <slot name="opera" :item="scope.row"></slot>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
        v-if="pageInfo.pageSize"
        align='right'
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.currentPage"
        :page-sizes="[3, 15, 30, 60]"
        :page-size="pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "tableMerge",
  props: ['tableData', 'tableConfig', 'tableField', 'pageInfo'],
  data() {
    return {
      tableConfigIn: {},
      tableFieldIn: [],
      multipleSelection: []
    }
  },
  created() {
    console.log(this.tableData)
    console.log(this.tableField)
    let that = this
    this.onInit().then(() => {
      that.tableConfigIn = that.tableConfig
    }).then(() => {
      that.tableFieldIn = that.tableField
    })
  },
  methods: {
    onInit() {
      return Promise.resolve();
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val
    },
    handleSizeChange(val) {
      console.log(val)
      this.pageInfo.pageSize = val
      this.$emit("update:pageInfo", this.pageInfo)
      this.$emit("update:pageInfoCoupon", this.pageInfo)
    },
    handleCurrentChange(val) {
      console.log(val)
      this.pageInfo.currentPage = val

      this.$emit("update:pageInfo", this.pageInfo)
      this.$emit("update:pageInfoCoupon", this.pageInfo)
    }
  }
}
</script>

<style scoped>

</style>